module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "element-general-properties card"
  }, [(Object.keys(_vm.element).length > 0) ? _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col d-flex"
  }, [_c('element-badge', {
    attrs: {
      "element": _vm.element
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-4"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.element.name))]), _vm._v(" "), _c('h6', {
    staticClass: "card-subtitle mb-2 text-muted"
  }, [_vm._v(_vm._s(_vm.$t("element.group." + _vm.element.elementGroup)))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mb-3"
  }, [_c('featured-value', {
    staticClass: "col-md-6 mt-4",
    attrs: {
      "value": _vm.element.atomicNumber,
      "title": "element.atomicNumber",
      "element": _vm.element,
      "colored": true
    }
  }), _vm._v(" "), _c('featured-value', {
    staticClass: "col-md-6 mt-4",
    attrs: {
      "value": _vm.element.atomicMass,
      "title": "element.atomicMass",
      "element": _vm.element,
      "colored": true
    }
  })], 1), _vm._v(" "), (!_vm.preview) ? _c('div', [(_vm.debug) ? _c('highlight', {
    attrs: {
      "data": _vm.element
    }
  }) : _vm._e(), _vm._v(" "), _c('line-chart', {
    attrs: {
      "element": _vm.element
    }
  })], 1) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4aea75d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ElementProfile/ElementGeneralProperties.vue
// module id = 640
// module chunks = 1